'use client';

import Head from 'next/head';
import { useEffect } from 'react';

import HeroSection from '@/components/HeroSection';
import HeaderSection from '@/components/HeaderSection';
import AboutSection from '@/components/AboutSection';
//import ClientsSection from '@/components/ClientSection';
import FeaturesSection from '@/components/FeaturesSection';
import ServicesSection from '@/components/ServiceSection';
import CallToActionSection from '@/components/CallToActionSection';
import StatsSection from '@/components/StatsSection';
import TeamSection from '@/components/TeamSection';
import ContactSection from '@/components/ContactSection';
import FooterSection from '@/components/FooterSection';
import Preloader from '@/components/Preloader';
import ScrollTopButton from '@/components/ScrollTopButton';

import { Poppins, Roboto, Raleway } from 'next/font/google';
import dynamic from 'next/dynamic';

// Dynamically import Swiper section to prevent SSR hydration mismatch
const PortfolioSection = dynamic(() => import('@/components/PortfolioSection'), { ssr: false });
const TestimonialsSection = dynamic(() => import('@/components/TestimonialsSection'), { ssr: false });

const poppins = Poppins({ subsets: ['latin'], weight: ['400', '600', '700'] });
const roboto = Roboto({ subsets: ['latin'], weight: ['400', '700'] });
const raleway = Raleway({ subsets: ['latin'], weight: ['400', '700'] });

export default function Home() {
  useEffect(() => {
    document.body.classList.add('index-page');
    return () => {
      document.body.classList.remove('index-page');
    };
  }, []);

  return (
    <>
      <Head>
        <title>Smart Service</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="utf-8" />
        <meta name="description" content="GP Bootstrap Next.js Conversion" />
        <meta name="keywords" content="Next.js, Bootstrap, Template, Business" />
        <link rel="icon" href="/assets/img/favicon.png" />
        <link rel="apple-touch-icon" href="/assets/img/apple-touch-icon.png" />
      </Head>

      <noscript>
        <div>Please enable JavaScript.</div>
      </noscript>

      <main className={`${poppins.className} ${roboto.className} ${raleway.className}`}>
        <HeaderSection />
        <HeroSection />
        <AboutSection />
         {/*  <ClientsSection /> */}      
        <FeaturesSection />
        <ServicesSection />
        <CallToActionSection />
        <PortfolioSection />
        <StatsSection />
        <TestimonialsSection />
        <TeamSection />
        <ContactSection />
        <FooterSection />
        <ScrollTopButton />
        <Preloader />
      </main>
    </>
  );
}
